<template>
	<v-row align="center" justify="center" :class="is_mobile_screen || is_tablet_screen ? 'flex-column-reverse' : ''">
		<div v-if="is_mobile_screen || is_tablet_screen" class="mobile-space"></div>
		<v-col cols="12" md="5" class="pr-md-10">
			<h2 class="pl-1 pb-4">
				{{ language.configuration.main_title }}
			</h2>

			<v-form v-model="validConfig" :class="{
				'scroll-container': !is_mobile_screen && !is_tablet_screen,
				'pb-16': is_desktop_screen,
			}">
				<!-- Porti auto section -->
				<v-row>
					<v-col cols="12" md="7">
						<v-subheader class="subtitle-1 pl-1 black--text">
							<span class="font-weight-bold">{{
								language.configuration.labels.label_obj1
							}}</span>
						</v-subheader>
					</v-col>
					<v-col cols="12" md="5">
						<v-radio-group class="mt-0 mt-md-2" v-model="configuration.poarta_a.is" row hide-details>
							<v-radio :label="language.configuration.labels.yes" :value="true"></v-radio>
							<v-radio :label="language.configuration.labels.no" :value="false"
								:disabled="disablePoartaA"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<!-- Porti auto section -->
				<div v-if="configuration.poarta_a.is">
					<v-row>
						<v-col cols="12" md="7" class="pt-0">
							<v-subheader class="subtitle-1 pl-1">{{
								language.configuration.labels.label_piece1
							}}</v-subheader>
						</v-col>
						<v-col cols="12" md="3" class="pt-0 mb-4 mb-md-0">
							<v-select v-model="configuration.poarta_a.buc" :items="[1, 2, 3]"
								:suffix="language.configuration.labels.piece" outlined dense hide-details
								@focusin="poarta_a_active = true" @focusout="poarta_a_active = false"
								@change="nrPortiAuto()">
							</v-select>
						</v-col>
					</v-row>

					<PoartaA v-for="(item, index) in configuration.poarta_a.items" :key="index" :item="item"
						:index="index" :model="model" :nr_porti="configuration.poarta_a.buc" :language="language"
						@changeActivePA="setStatusActivePA" @changedStatusPPA="setStatusAllPA"
						@changedTipPA="setStatusToPA" />

					<v-row v-if="poarta_a_TypeNo.includes('culisanta')">
						<v-col cols="12">
							<v-alert class="mt-2 pl-2" dense rounded="5" color="blue" dark dismissible>
								<span class="pl-1">{{
									language.configuration.labels.alert_text3
								}}</span>
							</v-alert>
						</v-col>
					</v-row>
				</div>
				<v-divider class="mt-2 mb-1" role="presentation"></v-divider>

				<!-- Porti pietonale section -->
				<v-row>
					<v-col cols="12" md="7">
						<v-subheader class="subtitle-1 pl-1 black--text">
							<span class="font-weight-bold">{{
								language.configuration.labels.label_obj2
							}}</span>
						</v-subheader>
					</v-col>
					<v-col cols="12" md="5">
						<v-radio-group class="mt-0 mt-md-2" v-model="configuration.poarta_p.is" row hide-details>
							<v-radio :label="language.configuration.labels.yes" :value="true"></v-radio>
							<v-radio :label="language.configuration.labels.no" :value="false"
								:disabled="disablePoartaP"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row v-if="configuration.poarta_p.is">
					<v-col cols="12" md="7" class="pt-0">
						<v-subheader class="subtitle-1 pl-1">{{
							language.configuration.labels.label_piece2
						}}</v-subheader>
					</v-col>
					<v-col cols="12" md="3" class="pt-0">
						<v-select v-model="configuration.poarta_p.buc" :items="[1, 2, 3]"
							:suffix="language.configuration.labels.piece" outlined dense
							@focusin="poarta_p_active = true" @focusout="poarta_p_active = false"
							@change="nrPortiPietonale()">
						</v-select>
					</v-col>
				</v-row>
				<div v-if="configuration.poarta_p.is" class="mt-2 mb-4">
					<v-row v-for="(item, index) in configuration.poarta_p.items" :key="index">
						<v-col cols="1" class="ml-2">
							<v-badge color="primary" :inline="true" :content="index + 1">
							</v-badge>
						</v-col>
						<v-col cols="4" class="pt-1">
							<!-- <v-subheader class="ml-md-2 pl-0 subtitle-1">Latime gol</v-subheader> -->
							<v-text-field class="ml-md-2" pattern="\d*" validate suffix="mm"
								:label="language.configuration.labels.field_label" outlined dense type="number"
								min="700" max="1200" :rules="[rules.minLengthPP]" v-model="item.latime_gol"
								@focusin="poarta_p_active = true" @focusout="poarta_p_active = false">
							</v-text-field>
						</v-col>
					</v-row>
				</div>
				<v-divider class="mt-2 mb-1" role="presentation"></v-divider>

				<!-- Panouri section -->
				<div :class="{ 'pb-16': is_desktop_screen }">
					<v-row class="mt-4 mb-4 mb-md-0">
						<v-col cols="12" md="7" class="py-0">
							<v-subheader class="subtitle-1 pl-1 black--text">
								<span class="font-weight-bold">{{
									language.configuration.labels.label_obj3
								}}</span>
							</v-subheader>
						</v-col>
						<v-col cols="12" md="5" class="py-0">
							<v-radio-group class="mt-0 mt-md-2" v-model="configuration.panouri.is" row hide-details>
								<v-radio :label="language.configuration.labels.yes" :value="true"></v-radio>
								<v-radio :label="language.configuration.labels.no" :value="false"
									:disabled="disablePanouri"></v-radio>
							</v-radio-group>
						</v-col>
					</v-row>
					<v-row v-if="configuration.panouri.is" class="">
						<!-- <v-col v-if="model == 'horizontal'" cols="12" md="7" class="py-0">
							<v-subheader class="subtitle-1 pl-1">
								<span>{{ language.configuration.labels.label_obj31 }}</span>
							</v-subheader>
						</v-col>
						<v-col v-if="model == 'horizontal'" cols="12" md="5" class="py-0">
							<v-radio-group class="mt-0 mt-md-2" v-model="configuration.panouri.panelFrame" row
								hide-details>
								<v-radio :label="language.configuration.labels.yes" :value="true"></v-radio>
								<v-radio :label="language.configuration.labels.no" :value="false"></v-radio>
							</v-radio-group>
						</v-col> -->
						<v-col cols="12">
							<v-alert v-if="configuration.panouri.panelFrame" class="pl-2" dense rounded="5" color="blue"
								dark dismissible>
								<strong>{{ language.configuration.labels.alert_text1 }}</strong>
								<span class="pl-1">{{
									language.configuration.labels.alert_text2
								}}</span>
							</v-alert>
						</v-col>
						<v-col cols="12" md="7" class="pt-0">
							<v-subheader class="subtitle-1 pl-1">{{
								language.configuration.labels.label_piece3
							}}</v-subheader>
							<p v-if="validConfig" class="caption ml-md-1">
								{{ language.configuration.labels.desc_text1 }}
								<span class="font-weight-bold">{{ Math.round(lPanou) }} mm</span>
							</p>
						</v-col>
						<v-col cols="12" md="4" class="pt-0">
							<v-col cols="12" md="9" class="pa-0">
								<v-text-field pattern="\d*" validate :suffix="language.configuration.labels.piece"
									outlined type="number" dense min="0" :hint="buc_hintText"
									:placeholder="String(midPanouri)" :rules="[rules.panouriMin]"
									v-model="configuration.panouri.buc" @focusin="panou_active = true"
									@focusout="panou_active = false">
									></v-text-field>
							</v-col>
						</v-col>
						<v-col cols="12" class="ml-md-1 pt-0">
							<p class="caption">
								{{ language.configuration.labels.desc_text2 }}
								<span class="font-weight-bold">{{ dimensions.lt }} {{ language.dimensions.meters }}
								</span>
								{{ language.configuration.labels.desc_text3 }}
							</p>
						</v-col>
					</v-row>
				</div>
			</v-form>
		</v-col>
		<!-- Right side -->
		<v-col cols="12" md="7">
			<v-row :style="'display: grid; grid-template-columns:' + gridTemplate" class="px-3">
				<div v-if="configuration.panouri.is > 0" :class="[
					'grid-jcenter',
					{
						'grid-jright':
							!configuration.poarta_a.is &&
							configuration.panouri.is &&
							configuration.poarta_p.is,
					},
				]">
					{{ configuration.panouri.buc }}
					{{ language.configuration.labels.piece }}
				</div>
				<div v-if="configuration.poarta_p.is > 0" class="grid-jcenter">
					{{ configuration.poarta_p.buc }}
					{{ language.configuration.labels.piece }}
				</div>
				<div v-if="configuration.poarta_a.is && poarta_ab_buc > 0" class="grid-jcenter">
					{{ poarta_ab_buc }} {{ language.configuration.labels.piece }}
				</div>
				<div v-if="configuration.poarta_a.is && poarta_ac_buc > 0" class="grid-jcenter">
					{{ poarta_ac_buc }} {{ language.configuration.labels.piece }}
				</div>
				<div v-if="configuration.poarta_a.is && poarta_aap_buc > 0" class="grid-jcenter">
					{{ poarta_aap_buc }} {{ language.configuration.labels.piece }}
				</div>
				<div v-if="configuration.poarta_a.is && poarta_aap_buc > 0" class="grid-jcenter">
					&nbsp;
				</div>
			</v-row>
			<v-img class="mx-auto flex-shrink-1" max-width="100%"
				:src="require('../assets/img/config/' + imgLink)"></v-img>
		</v-col>
		<v-col cols="6">
			<!-- <pre>{{ PPIncludedType }}</pre> -->

			<!-- <pre>{{ imgLink }}</pre> -->
			<!-- <pre>{{midPanouri}}</pre> -->
		</v-col>
		<v-col cols="6">
			<!-- <pre>{{ configuration }}</pre> -->
		</v-col>
	</v-row>
</template>

<script>
import PoartaA from "@/components/PoartaA";

export default {
	name: "Configuration",
	components: {
		PoartaA,
	},
	data: function () {
		return {
			configuration: {
				panouri: {
					is: true,
					panelFrame: false,
					buc: 7,
				},
				poarta_p: {
					is: true,
					buc: 1,
					items: [
						{
							latime_gol: 1000,
						},
					],
				},
				poarta_a: {
					is: true,
					buc: 1,
					items: [
						{
							latime_gol: 3500,
							tip: "batanta",
							automation: false,
							pp_included: false,
							latime_pp: 900,
						},
					],
				},
			},
			modalAutomation: false,
			panou_active: false,
			poarta_p_active: false,
			poarta_ab_active: false,
			poarta_ab_pp_active: false,
			poarta_ac_active: false,
			poarta_ac_pp_active: false,
			poarta_aap_active: false,
			poarta_aap_pp_active: false,
			validConfig: false,
			latime_min_panou: 400,
			latime_mid_panou: 2000,
			latime_max_panou: 6000,
			rules: {
				minLengthPP: (value) =>
					(value >= 700 && value <= 1200) ||
					`${this.language.configuration.labels.minimum} 700mm  ${this.language.configuration.labels.maximum} 1200mm`,
				panouriMin: (v) =>
					(v >= this.minPanouri && v <= this.maxPanouri) ||
					`${this.language.configuration.labels.minimum} ${this.minPanouri} ${this.language.configuration.labels.piece} ${this.language.configuration.labels.maximum} ${this.maxPanouri} ${this.language.configuration.labels.piece}`,
			},
		};
	},
	props: [
		"language",
		"is_mobile_screen",
		"is_tablet_screen",
		"is_desktop_screen",
		"model",
		"dimensions",
		"lStalp",
		"lPanou",
	],
	computed: {
		gridTemplate() {
			let grid;
			switch (this.poarta_a_TypeNo.length) {
				case 3:
					if (this.poarta_aap_buc > 0) {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "16% 7% 23% 21% 21% 20%";
						} else if (this.configuration.panouri.is) {
							grid = "18% 20% 28% 20% 20%";
						} else if (this.configuration.poarta_p.is) {
							grid = "13% 22% 28% 22% 20%";
						} else {
							grid = "30% 28% 27% 20%";
						}
					} else {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "16% 11% auto auto auto;";
						} else if (this.configuration.panouri.is) {
							grid = "21% 21% 33% 20%;";
						} else if (this.configuration.poarta_p.is) {
							grid = "15% 23% 36% 21%";
						} else {
							grid = "auto auto auto";
						}
					}
					break;
				case 2:
					if (this.poarta_aap_buc > 0) {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "21% 7% 33% auto 20%";
						} else if (this.configuration.panouri.is) {
							grid = "25% 25% 38% 20%";
						} else if (this.configuration.poarta_p.is) {
							grid = "18% 28% 41% 20%";
						} else {
							grid = "auto auto 20%";
						}
					} else {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "25% 7% auto auto;";
						} else if (this.configuration.panouri.is) {
							grid = "26% 35% 38%;";
						} else if (this.configuration.poarta_p.is) {
							grid = "20% 36% 44%;";
						} else {
							grid = "auto auto";
						}
					}
					break;
				default:
					if (this.configuration.poarta_a.is && this.poarta_aap_buc > 0) {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "30% 10% auto 20%";
						} else if (this.configuration.panouri.is) {
							grid = "35% 38% 20%";
						} else if (this.configuration.poarta_p.is) {
							grid = "34% 28% 20%";
						} else {
							grid = "auto";
						}
					} else if (this.configuration.poarta_a.is) {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "30% 20% auto";
						} else if (this.configuration.panouri.is) {
							grid = "52% 26%";
						} else if (this.configuration.poarta_p.is) {
							grid = "52% 15%";
						} else {
							grid = "auto";
						}
					} else {
						if (
							this.configuration.panouri.is &&
							this.configuration.poarta_p.is
						) {
							grid = "43% 43%;";
						} else if (this.configuration.panouri.is) {
							grid = "auto;";
						} else if (this.configuration.poarta_p.is) {
							grid = "auto;";
						} else {
							grid = "auto";
						}
					}
			}
			return grid;
		},
		disablePanouri() {
			return !this.configuration.poarta_a.is && !this.configuration.poarta_p.is;
		},
		disablePoartaP() {
			return !this.configuration.poarta_a.is && !this.configuration.panouri.is;
		},
		disablePoartaA() {
			return !this.configuration.poarta_p.is && !this.configuration.panouri.is;
		},
		buc_hintText() {
			return `${this.language.configuration.labels.minimum} ${this.minPanouri} ${this.language.configuration.labels.piece} ${this.language.configuration.labels.maximum} ${this.maxPanouri} ${this.language.configuration.labels.piece}`;
		},
		panouriLength() {
			let l_totala = Number(this.dimensions.lt) * 1000 - this.lStalp;
			if (this.configuration.poarta_p.is) {
				l_totala =
					l_totala -
					this.configuration.poarta_p.buc *
					(Number(this.configuration.poarta_p.items[0].latime_gol) +
						this.lStalp);
			}
			if (this.configuration.poarta_a.is) {
				l_totala =
					l_totala -
					this.configuration.poarta_a.buc *
					(Number(this.configuration.poarta_a.items[0].latime_gol) +
						this.lStalp);
			}
			return Number(l_totala);
		},
		minPanouri() {
			let buc = 1;
			// for (let i = 1; i < 140; i++) {
			// 	let dim = this.panouriLength / i - this.lStalp;
			// 	if (dim < this.latime_max_panou) {
			// 		buc = i;
			// 		break;
			// 	}
			// }
			return buc;
		},
		midPanouri() {
			let buc = 1;
			for (let i = 1; i < 140; i++) {
				let dim = this.panouriLength / i - this.lStalp;
				if (dim < this.latime_mid_panou) {
					buc = i;
					break;
				}
			}
			return buc;
		},
		maxPanouri() {
			let buc = 1;
			for (let i = 1; i < 140; i++) {
				let dim = this.panouriLength / i - this.lStalp;
				if (dim < this.latime_min_panou) {
					buc = i;
					break;
				}
			}
			return buc - 1;
		},
		poarta_ab_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "batanta") {
					count++;
				}
			});
			return count;
		},
		poarta_ac_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "culisanta") {
					count++;
				}
			});
			return count;
		},
		poarta_aap_buc() {
			let count = 0;
			this.configuration.poarta_a.items.forEach((poarta) => {
				if (poarta.tip == "autoportanta") {
					count++;
				}
			});
			return count;
		},
		poarta_a_TypeNo() {
			let arrPA = [];
			this.configuration.poarta_a.items.forEach((item) => {
				if (!arrPA.includes(item.tip)) {
					arrPA.push(item.tip);
				}
			});
			return arrPA;
		},
		isPPIncluded() {
			let count = false;
			this.configuration.poarta_a.items.forEach((item) => {
				if (item.pp_included) {
					count = true;
					return;
				}
			});
			return count;
		},
		PPIncludedType() {
			let type = "";
			let types = [];
			this.configuration.poarta_a.items.forEach((item) => {
				if (item.pp_included) {
					if (!types.includes(item.tip)) {
						types.push(item.tip);
					}
				}
			});
			if (types.length == 3) {
				type = "pp123_";
			} else if (types.length == 2) {
				if (types.includes("batanta")) {
					if (types.includes("culisanta")) {
						type = "pp12_";
					} else {
						type = "pp13_";
					}
				} else {
					type = "pp23_";
				}
			} else if (types.length == 1) {
				if (types.includes("batanta")) {
					type = "pp1_";
				} else if (types.includes("culisanta")) {
					type = "pp2_";
				} else {
					// if (this.configuration.poarta_a.items.length < 3) {
					// 	type = "pp2_";
					// } else {
					// 	type = "pp3_";
					// }
					type = "pp3_";
				}
			}
			return type;
		},
		activePanel() {
			if (this.panou_active) {
				return 1;
			} else if (this.poarta_p_active) {
				return 2;
			} else if (this.poarta_ab_active) {
				return 3;
			} else if (this.poarta_ab_pp_active) {
				return 6;
			} else if (this.poarta_ac_active) {
				if (this.poarta_a_TypeNo.length > 1) {
					return 4;
				} else {
					return 3;
				}
			} else if (this.poarta_ac_pp_active) {
				return 7;
			} else if (this.poarta_aap_active) {
				if (this.poarta_a_TypeNo.length > 1) {
					return 5;
				} else {
					return 3;
				}
			} else if (this.poarta_aap_pp_active) {
				return 8;
			} else {
				return 0;
			}
		},
		poarta_a_img() {
			let imgCode = 1;

			if (this.poarta_a_TypeNo.length == 3) {
				imgCode = 7;
			} else if (this.poarta_a_TypeNo.length == 2) {
				let nr;
				if (this.poarta_a_TypeNo.includes("batanta")) {
					if (this.poarta_a_TypeNo.includes("culisanta")) {
						nr = 4;
					} else if (this.poarta_a_TypeNo.includes("autoportanta")) {
						nr = 6;
					}
				} else {
					// if culisanta + autoportanta
					nr = 5;
				}
				imgCode = nr;
			} else if (this.configuration.poarta_a.items[0].tip == "culisanta") {
				imgCode = 2;
			} else if (this.configuration.poarta_a.items[0].tip == "autoportanta") {
				imgCode = 3;
			} else {
				// batanta
				imgCode = 1;
			}

			return imgCode;
		},
		imgLink() {
			// default is
			let one = 1;
			let two = 1;

			if (this.configuration.poarta_p.is && this.configuration.poarta_a.is) {
				if (this.configuration.panouri.is) {
					one = 4;
				} else {
					one = 7;
				}
				two = this.poarta_a_img;
			} else if (this.configuration.poarta_a.is) {
				if (this.configuration.panouri.is) {
					one = 3;
				} else {
					one = 6;
				}
				two = this.poarta_a_img;
			} else if (this.configuration.poarta_p.is) {
				if (this.configuration.panouri.is) {
					one = 2;
				} else {
					one = 5;
				}
			} else {
				if (!this.configuration.panouri.is) {
					one = 0;
					two = 0;
				}
			}

			let frameAdd =
				this.configuration.panouri.is && this.configuration.panouri.panelFrame
					? "r_"
					: "";
			// let PPIncludedAdd =
			// 	this.configuration.poarta_a.is && this.isPPIncluded ? "pp_" : "";

			let name =
				this.model +
				"_" +
				String(one) +
				"_" +
				String(two) +
				"_" +
				frameAdd +
				this.PPIncludedType +
				String(this.activePanel);
			return name + ".png";
		},
	},
	watch: {
		configuration: {
			handler: function () {
				this.$emit("changeConfig", {
					configuration: this.configuration,
					img: this.imgLink,
				});
			},
			deep: true,
		},
		"configuration.poarta_a.is"(value) {
			if (!value) {
				this.configuration.poarta_a.buc = 1;
				this.nrPortiAuto();
			}
		},
		midPanouri(value) {
			this.configuration.panouri.buc = value;
		},
		validConfig() {
			this.$emit("validConfig", this.validConfig);
		},
	},
	methods: {
		setStatusAllPA(payload) {
			this.configuration.poarta_a.items.forEach((item, index) => {
				if (
					index != payload.index &&
					item.tip == this.configuration.poarta_a.items[payload.index].tip
				) {
					item.pp_included = payload.value;
				}
			});
		},
		setStatusToPA(payload) {
			this.configuration.poarta_a.items.forEach((item, index) => {
				if (item.tip == payload.value && index != payload.index) {
					this.configuration.poarta_a.items[payload.index].pp_included =
						item.pp_included;
				}
			});
		},
		setStatusActivePA(value, tip, isPP) {
			if (tip == "batanta") {
				if (isPP) {
					this.poarta_ab_pp_active = value;
				} else {
					this.poarta_ab_active = value;
				}
			} else if (tip == "culisanta") {
				if (isPP) {
					this.poarta_ac_pp_active = value;
				} else {
					this.poarta_ac_active = value;
				}
			} else {
				if (isPP) {
					this.poarta_aap_pp_active = value;
				} else {
					this.poarta_aap_active = value;
				}
			}
		},
		ifPanels(val) {
			this.configuration.panouri.is = val;
		},
		addAutomation(idx) {
			this.configuration.poarta_a.items[idx].automation = true;
		},
		removeAutomation(idx) {
			this.configuration.poarta_a.items[idx].automation = false;
		},
		nrPortiAuto() {
			if (
				this.configuration.poarta_a.buc >
				this.configuration.poarta_a.items.length
			) {
				let newItem = {
					latime_gol: 3500,
					tip: "batanta",
					automation: false,
					pp_included: false,
					latime_pp: 900,
				};
				if (
					this.configuration.poarta_a.buc -
					this.configuration.poarta_a.items.length ==
					1
				) {
					this.configuration.poarta_a.items.push(newItem);
				} else {
					let newItem2 = {
						latime_gol: 3500,
						tip: "batanta",
						automation: false,
						pp_included: false,
						latime_pp: 900,
					};
					this.configuration.poarta_a.items.push(newItem, newItem2);
				}
			} else if (
				this.configuration.poarta_a.buc <
				this.configuration.poarta_a.items.length
			) {
				if (
					this.configuration.poarta_a.items.length -
					this.configuration.poarta_a.buc ==
					1
				) {
					this.configuration.poarta_a.items.splice(
						this.configuration.poarta_a.items.length - 1,
						1
					);
				} else {
					this.configuration.poarta_a.items.splice(
						this.configuration.poarta_a.items.length - 2,
						2
					);
				}
			}
		},
		nrPortiPietonale() {
			if (
				this.configuration.poarta_p.buc >
				this.configuration.poarta_p.items.length
			) {
				let newItem = {
					latime_gol: 1000,
				};
				if (
					this.configuration.poarta_p.buc -
					this.configuration.poarta_p.items.length ==
					1
				) {
					this.configuration.poarta_p.items.push(newItem);
				} else {
					let newItem2 = {
						latime_gol: 1000,
					};
					this.configuration.poarta_p.items.push(newItem, newItem2);
				}
			} else if (
				this.configuration.poarta_p.buc <
				this.configuration.poarta_p.items.length
			) {
				if (
					this.configuration.poarta_p.items.length -
					this.configuration.poarta_p.buc ==
					1
				) {
					this.configuration.poarta_p.items.splice(
						this.configuration.poarta_p.items.length - 1,
						1
					);
				} else {
					this.configuration.poarta_p.items.splice(
						this.configuration.poarta_p.items.length - 2,
						2
					);
				}
			}
		},
	},
};
</script>

<style lang="css">
.grid-jcenter {
	justify-self: center;
}

.grid-jright {
	justify-self: right;
}
</style>
